import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/migration/tenant.migration.resend.mutation.gql"
import type {
  TenantActivationResendMutation,
  TenantActivationResendMutationVariables,
} from "@/v2-backoffice-client/tenant/migration/__types__/tenant.migration.resend.mutation"

type Options = MutationHookOptions<
  TenantActivationResendMutation,
  TenantActivationResendMutationVariables
>

export function useTenantActivationResendMutation(options?: Options) {
  return useMutation<
    TenantActivationResendMutation,
    TenantActivationResendMutationVariables
  >(mutation, options)
}
